import React from 'react';

/**
 * Hover Border Gradient（Aceternity UI 风格）— 悬停时展开的渐变边框光晕
 */
export function HoverBorderGradient({
  children,
  containerClassName = '',
  className = '',
  as: Tag = 'button',
  ...props
}: {
  children: React.ReactNode;
  containerClassName?: string;
  className?: string;
  as?: any;
  [key: string]: any;
}) {
  return (
    <Tag
      className={'group relative flex rounded-xl bg-transparent transition duration-300 ' + containerClassName}
      {...props}
    >
      {/* 悬停外发光 */}
      <div className="absolute inset-0 rounded-xl bg-[radial-gradient(circle_at_center,#e11d2e_0%,transparent_70%)] opacity-0 blur-md transition-opacity duration-500 group-hover:opacity-80" />
      {/* 渐变描边 */}
      <div className="absolute -inset-px rounded-xl bg-[linear-gradient(120deg,#e11d2e,#ff5c75,#8f0f20,#ffd0d6)] opacity-0 transition-opacity duration-500 group-hover:opacity-100" />
      <div className="relative rounded-xl border border-border-soft bg-card/90 backdrop-blur-xl">
        <div className={'relative ' + className}>{children}</div>
      </div>
    </Tag>
  );
}
